import { Store } from 'redux'

const firstPaintHandler = (store: Store): void => {
  if (!window.velorbisFirstPaintCallback) {
    return
  }

  const check = (): void => {
    const {
      bikeImage: { loaded }
    } = store.getState()
    if (loaded) {
      unsubscribe()
      // Wait for three animation frames to let the canvas and background CSS settle
      let framesLeft = 3
      const checkFrames = (): void => {
        if (framesLeft <= 0) {
          window.velorbisFirstPaintCallback!()
        } else {
          framesLeft--
          window.requestAnimationFrame(checkFrames)
        }
      }
      checkFrames()
    }
  }

  const unsubscribe = store.subscribe(check)
}

export default firstPaintHandler
